export enum LocationTypes {

  None = 'None',
  NotApplicable = 'Not Applicable'
}
